module.exports = __webpack_public_path__ + "media/logos/facebook-logo-white-c25088fd.svg";